export const styles = {
  uploadContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
  },

  imageUploadBox: {
    width: '178px',
    height: '100px',
    background: '#FAFBFC',
    border: '1px solid #EDEFF7',
    borderRadius: '8px',
    display: 'flex',
    overflow: 'hidden',
    '& svg': {
      margin: 'auto',
    },
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },

  uploadInput: {
    display: 'flex',
    flexDirection: 'row',
    gap: '16px',
    '& input': {
      display: 'none',
    },
    '& label': {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      borderRadius: '8px',
      cursor: 'pointer',
      userSelect: 'none',
    },
    '& .add-selection-image': {
      border: '1px solid #4D6EF5',
      color: '#4D6EF5',
      background: '#FFF',
    },
    '& .remove-selection-image': {
      border: '1px solid #EDEFF7',
      background: '#FFF',
      color: '#23252F',
      fontFamily: 'Inter',
      fontSize: '14px',
      fontWeight: '400px',
    },
  },
};
